/**
 * Copyright (c) 2019, Tidepool Project
 *
 * This program is free software; you can redistribute it and/or modify it under
 * the terms of the associated License, which is identical to the BSD 2-Clause
 * License as published by the Open Source Initiative at opensource.org.
 *
 * This program is distributed in the hope that it will be useful, but WITHOUT
 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
 * FOR A PARTICULAR PURPOSE. See the License for more details.
 *
 * You should have received a copy of the License along with this program; if
 * not, you can obtain one from Tidepool Project at tidepool.org.
 */

import React from 'react';
import { Stepper, Step, StepLabel } from '@material-ui/core';
import { Flex } from 'rebass';
import { Caption } from '../../../components/FontStyles';
import { makeStyles } from '@material-ui/core/styles';
import * as _ from '../../../data/constants.js';

const useStyles = makeStyles(theme => ({
	root: {
		width: '100%',
		display: 'flex',
		flexDirection: 'column',
		flexWrap: 'wrap'
	},
	button: {
		marginRight: theme.spacing(1)
	}
}));

// Progress bar component appears at the top of the form, helping keep track of which step active
const ProgressBar = props => {
	const classes = useStyles();
	const steps = _.ProgressBarStepNames;

	return (
		<div className={classes.root}>
			<Stepper activeStep={props.activeSection}>
				{steps.map((label, index) => {
					const stepProps = {};
					const labelProps = {};
					return (
						<Step key={label} onClick={() => props.setFieldValue('activeSection', index)} {...stepProps}>
							<StepLabel {...labelProps}>
								<Flex display={['none', 'none', 'flex', 'flex']}>
									<Caption>{label}</Caption>
								</Flex>
							</StepLabel>
						</Step>
					);
				})}
			</Stepper>
		</div>
	);
};

export default ProgressBar;
